module.exports = __webpack_public_path__ + "assets/img/tit1.6c6caa55.png";